module.exports = __webpack_public_path__ + "media/images/logo/yt-94e6da7e7f52cf63eb4587eb31e1c4b9.svg";